module.exports = {
  WinName: 'Выбор шаблона',
  TemplateName: 'Название шаблона',
  OK: 'Подтвердить',
  Cancel: 'Отмена',
  QueryTemplateFailed: 'Ошибка поиска шаблона!',
  Tips: 'Подсказка',
  PlsSelectTemplate: 'Пожалуйста, выберите шаблон!',
  Copy: 'Копировать',
  TemplateTypes: 'Тип шаблона',
  EmailTemp: 'Показать шаблон письма',
  viewV3: 'Показать шаблон V3',
  inputTemplateName: 'Ввод названия шаблона',
  notFoundTemplate: 'Шаблон данного типа не найден, пожалуйста, сначала добавьте шаблон!',
  batchPrintMore: 'Объем данных для массовой печати превышает {0} записей (максимум системы), система не может загрузить, свяжитесь с онлайн-поддержкой!',
  noSchemaType: 'SchemaType не обслуживается!',
  printMore: 'Количество записей для печати превышает 100, загрузка может занять больше времени, продолжить печать?',
  notFoundTemplateFromData: 'Шаблон 【{0}】 не найден, проверьте шаблон!',
  notEmptyTemplateName: 'Название шаблона не может быть пустым!',
  hasFoundTemplateName: 'Название шаблона уже существует!',
  attachmentLarge: 'Содержимое вложения слишком большое!',
  smtpServerError: 'Ошибка SMTP-сервера!',
  unConnectSmtp: 'Не удалось подключиться к SMTP-серверу!',
  notFoundFile: 'Система не может найти указанный файл!',
  fileSendError: 'Ошибка отправки файла!',
  attachmentTemplateError: 'Ошибка шаблона вложения!',
  sendEmailSuccess: 'Письмо успешно отправлено!'
}
